import List from "./List"

export default {
  namespaced: true,
  modules: {
    List
  }
}
